import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GeoGuard({ children }) {
  const [state, setState] = useState({ ready: false, blocked: false });

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/geo/check`, { timeout: 5000 });
        if (!cancelled) setState({ ready: true, blocked: !!data.blocked });
      } catch {
        // Fail open: never block on error
        if (!cancelled) setState({ ready: true, blocked: false });
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  if (!state.ready) {
    // Silent gate. No flash of blocked content.
    return <div className="fixed inset-0 bg-bg" data-testid="geo-guard-loading" />;
  }

  if (state.blocked) {
    return (
      <main
        className="min-h-screen flex flex-col items-center justify-center bg-bg px-6 text-center"
        data-testid="geo-blocked"
      >
        <p className="font-sans text-xs uppercase tracking-mega text-brass mb-6">A note</p>
        <h1 className="font-serif text-4xl md:text-5xl text-ink max-w-xl leading-tight">
          This practice is not currently accepting clients from your region.
        </h1>
        <p className="mt-6 font-sans text-ink-muted max-w-md leading-relaxed">
          Get Virtual Growth is a small growth and technology partner serving founders in the United States,
          United Arab Emirates, United Kingdom, Georgia, the Netherlands, and Australia.
          If you believe this is an error, please write to <span className="text-ink">hello@GetVirtualGrowth.com</span>.
        </p>
        <div className="mt-10 h-px w-16 bg-line" />
        <p className="mt-8 font-serif italic text-lg text-ink-muted">
          Thank you for stopping by.
        </p>
      </main>
    );
  }

  return children;
}
